import React, { useEffect, useState } from "react";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useTableSearch } from "core/Operations/useTableSearch";
import Error404 from "MainPages/ErrorPages/error404";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Edit, PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import TableTop from "Components/UI/TableTop";
import Select from "react-select";
import { useGetEmpAdditionsQuery } from "AppQuries/payroll/addition/emp-addition";
import Datatable from "core/pagination/datatable";
import { useGetAllDepartmentQuery } from "AppQuries/master/Department/get-all-departments";
import { useGetAdditionsQuery } from "AppQuries/payroll/addition/get-all-additions";
import { format, set, startOfMonth, endOfMonth } from "date-fns";
import { DatePicker } from "antd";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import dayjs from "dayjs";
import { useGetEmpAdditionDeductionQuery } from "AppQuries/payroll/emp-allowance-deduction";
import { useGetDeductionsQuery } from "AppQuries/payroll/deduction/get-all-deduction";
import ReportTools from "Components/UI/ReportTools";
import { toast } from "core/Operations/toast";
import PropTypes from "prop-types";
const { RangePicker } = DatePicker;

const AllocatedAllowanceDeductionList = ({
  companyCode,
  locationCode,
  employeeCode,
  departmentCode,
  type,
  typeCode,
  fromDate,
  toDate,
}) => {
  
  const {
    data,
    isFetching,
    isError,
    error,
    refetch: getEmpAllowance,
  } = useGetEmpAdditionDeductionQuery(
    {
      companyCode: companyCode,
      locationCode: locationCode,
      employeeCode: employeeCode,
      departmentCode: departmentCode,
      type: type,
      typeCode: typeCode,
      fromDate: fromDate,
      toDate: toDate,
    },
    {
      enabled: Boolean(
        companyCode && locationCode && employeeCode && departmentCode
      ),
    }
  );

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      sorter: (a, b) => a.uniqueID.length - b.uniqueID.length,
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      sorter: (a, b) => a.employeeName.length - b.employeeName.length,
      render: (text, record) => (
        <Link
          to={`${all_routes.employee}${all_routes.employee_view}/${record.employeeCode}`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: "Allowance Name",
      dataIndex: "description",
      sorter: (a, b) => a.description.length - b.description.length,
    },

    // {
    //   title: "have CPF",
    //   dataIndex: "haveCPF",
    //   sorter: (a, b) => a.haveCPF.length - b.haveCPF.length,
    //   render: (text, record) => (
    //     <>
    //       {text === true && <div className="bg-lightgreen">Yes</div>}
    //       {text === false && <div className="bg-lightred">No</div>}
    //     </>
    //   ),
    // },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => a.amount.length - b.amount.length,
    },
    {
      title: "Start Date",
      dataIndex: "effectiveDateFrom",
      sorter: (a, b) => a.effectiveDateFrom.length - b.effectiveDateFrom.length,
    },

    {
      title: "End Date",
      dataIndex: "effectiveDateTo",
      sorter: (a, b) => a.effectiveDateTo.length - b.effectiveDateTo.length,
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="edit-tooltip">Edit</Tooltip>}
          >
            {record.isEditable ? (
              <Link
                className="me-2 p-2"
                to={`${all_routes.edit_emp_allowance_deduction}/${record.allowanceCode}`}
              >
                <Edit className="feather-edit" />
              </Link>
            ) : (
              <Link
                className="me-2 p-2"
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toast.warning("Payroll was generate for this item");
                }}
              >
                <Edit className="feather-edit" />
              </Link>
            )}
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  return (
    <div className="card table-list-card border-0">
      <div className="card-body">
        <div className="table-responsive">
          <Datatable
            columns={columns}
            dataSource={data}
            rowKey={(record) => record.key}
            pagination={false}
          />
        </div>
      </div>
    </div>
  );
};

AllocatedAllowanceDeductionList.propTypes = {
  companyCode: PropTypes.number.isRequired,
  locationCode: PropTypes.string.isRequired,
  employeeCode: PropTypes.number.isRequired,
  departmentCode: PropTypes.number.isRequired,
  type: PropTypes.number.isRequired,
  typeCode: PropTypes.string.isRequired,
  fromDate: PropTypes.string.isRequired,
  toDate: PropTypes.string.isRequired,
};

export default AllocatedAllowanceDeductionList;
